<template>
<div
    class="test-card card"
    :class="{
        'is-disabled': isAnyRequestInProgress,
        'is-active': test.is_active,
    }"
    @click="startTestHandler"
>
    <div class="card-header">
        <span :title="test.name" class="card-header__title">
            {{  test.name }}
        </span>
        <div
            class="test-management-buttons ml-auto"
            v-if="test.is_user_can.update"
        >
            <div class="test-edit-button toggle-active-button" v-if="!!test.questions_count">
                <toggle-button
                    :title="trans.edit_form.activating.label"
                    v-model="test.is_active"
                    :is-disabled="isAnyRequestInProgress"
                    :callback="toggleActiveHandler"
                />
            </div>
            <div class="test-edit-button icon" @click.stop="editTestHandler">
                <svg>
                    <use xlink:href="#icon-pencil"></use>
                </svg>
            </div>
            <div class="test-delete-button icon" @click.stop="deleteTestHandler">
                <svg>
                    <use xlink:href="#icon-cross"></use>
                </svg>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div :title="dateAndTime">
            {{ date }}
        </div>
        <div class="test-statistics ml-auto" :class="{'test-statistics__link': test.sessions_count > 0}">
            <div class="is-flex" v-if="test.is_user_can.update" @click.stop="showTestStatisticHandler">
                <div class="icon">
                    <svg>
                        <use xlink:href="#test-statistic"></use>
                    </svg>
                </div>
                <span>
                    {{ test.sessions_count }}
                </span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ToggleButton from "../../../utils/forms/ToggleButton";

export default {
    name: "TestListCard",
    components: {ToggleButton},
    props: {
        test: Object,
        isDisabled: false,
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'isAnyRequestInProgress',
        ]),
        date() {
            return this._dateFormat(this.test.created_at);
        },
        dateAndTime() {
            return this._dateTimeFormat(this.test.created_at);
        },
    },
    methods: {
        ...mapActions('tests', [
            'editTest',
            'showDeleteConfirmationModal',
            'hideConfirmationModal',
            'deleteTest',
            'showStartConfirmationPage',
            'toggleActiveTest',
            'showTestStatistic',
        ]),
        toggleActiveHandler(value) {
            this.toggleActiveTest({test: this.test, value});
        },
        editTestHandler() {
            this.editTest(this.test);
        },
        deleteTestHandler() {
            this.showDeleteConfirmationModal({
                text: this.replaceWildcards(this.trans.edit_form.modals.delete_test_text, {
                    test_name: this.test.name,
                }),
                confirmationHandler: this.deleteCurrentTest,
                cancelHandler: this.hideConfirmationModal,
            })
        },
        deleteCurrentTest() {
            this.deleteTest(this.test);
            this.hideConfirmationModal();
        },
        startTestHandler() {
            if (!this.test.is_active) {
                return;
            }

            this.showStartConfirmationPage(this.test);
        },
        showTestStatisticHandler() {
            if (this.test.sessions_count > 0) {
                this.showTestStatistic(this.test);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/variables';

.card-header {
    box-shadow: none;
    margin-bottom: 0;
    font-weight: 600;

    &__title {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
}

.card-footer {
    border: none;
    max-height: 20%;
    margin-top: auto;
    color: $grey;
}

.test-management-buttons {
    display: flex;

    .toggle-active-button {
        padding-right: 5.5px;
    }

    .icon {
        height: 18px;
        padding: 0 3.5px;
        color: $grey;
        fill: $grey;

        &:last-child {
            padding-right: 0;
        }

        &:first-child {
            margin-left: 7px;
        }

        & svg {
            width: 13px;
            height: 13px;
        }
    }

    .icon.test-edit-button:hover {
        color: $tests-blue;
        fill: $tests-blue;
    }

    .icon.test-delete-button:hover {
        color: $tests-red;
        fill: $tests-red;
    }

 }

.test-statistics {
    display: flex;

    .icon {
        height: 18px;
        padding: 0 3.5px;
        color: $grey;
        fill: $grey;

        & svg {
            width: 15px;
            height: 15px;
        }
    }

    &__link {
        &:hover {
            .icon {
                color: $tests-blue;
                fill: $tests-blue;
            }

            color: $tests-blue;
        }
    }
}
</style>
